// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-circle.icon-circle[data-v-373ddb50]{background-color:var(--g-color-secondary);color:var(--g-color-on-secondary)}.icon-circle.icon-circle--dull[data-v-373ddb50]{background-color:var(--g-color-gray-200);color:var(--g-color-gray-900)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
